module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1008-55f8f97d2293e1b7b8adfbdedbe67ee1.png";